import { render, staticRenderFns } from "./TodayCafe.vue?vue&type=template&id=b4927b5a"
import script from "./TodayCafe.vue?vue&type=script&lang=js"
export * from "./TodayCafe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports